// src/pages/Hackathon/RegistrationForm.tsx
import RegistrationForm from "../../components/Hackathons/RegistrationForm";

export default function RegistrationFormPage() {
  return <RegistrationForm />;
}